module.exports = __webpack_public_path__ + "img/backgroundImg.80c95210.png";